import { render, staticRenderFns } from "./job.vue?vue&type=template&id=a1c27a70&"
import script from "./job.vue?vue&type=script&lang=js&"
export * from "./job.vue?vue&type=script&lang=js&"
import style0 from "./job.vue?vue&type=style&index=0&id=a1c27a70&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports